/** Deep links for hub entity detail pages (batch, sales order, shipment). */

export const INSIDE_SALES_SALES_ORDERS_PATH = "/inside-sales/sales-orders";

export function buildSalesOrderOverviewPath(search?: string | null): string {
  const trimmed = search?.trim() ?? "";
  if (trimmed === "") {
    return INSIDE_SALES_SALES_ORDERS_PATH;
  }
  const params = new URLSearchParams();
  params.set("search", trimmed);
  return `${INSIDE_SALES_SALES_ORDERS_PATH}?${params.toString()}`;
}

export function buildSalesOrderDetailPath(salesOrderId: number | string): string {
  return `/manufacturing-management/sales-order-details/${encodeURIComponent(String(salesOrderId))}`;
}

export function buildInsideSalesSalesOrderEditPath(orderIdOrNumber: number | string): string {
  return `${INSIDE_SALES_SALES_ORDERS_PATH}/${encodeURIComponent(String(orderIdOrNumber))}`;
}

export function buildInsideSalesApprovalPath(approvalTicketId: number | string): string {
  return `/inside-sales/approvals/${encodeURIComponent(String(approvalTicketId))}`;
}

export function buildSalesOrderNewPath(): string {
  return `${INSIDE_SALES_SALES_ORDERS_PATH}/new`;
}

export function buildSalesOrderSettingsPath(): string {
  return "/inside-sales/settings";
}

export function buildSalesOrderApprovalsPath(): string {
  return `${INSIDE_SALES_SALES_ORDERS_PATH}/approvals`;
}

export function buildSalesOrderApprovalTicketPath(ticketId: number | string): string {
  const params = new URLSearchParams();
  params.set("ticket", String(ticketId));
  return `${buildSalesOrderApprovalsPath()}?${params.toString()}`;
}

export function buildShippingShipmentDetailsPath(shipmentId: number): string {
  const params = new URLSearchParams();
  params.set("shipment_id", String(shipmentId));
  return `/shipping/shipment-details?${params.toString()}`;
}

export function buildWirelessPortalDeviceDetailsUrl(imei: string): string {
  return `https://portal-sgs.com/device-details/?id=${encodeURIComponent(imei.trim())}`;
}

export function buildShippingOutboundPathForShipment(shipmentId: number): string {
  const params = new URLSearchParams();
  params.set("shipment_id", String(shipmentId));
  return `/shipping/outbound?${params.toString()}`;
}

export function buildShippingGosiDetailsPath(mvDocumentId: number, search?: string | null): string {
  const params = new URLSearchParams();
  params.set("mv_document_id", String(mvDocumentId));
  const trimmedSearch = search?.trim();
  if (trimmedSearch != null && trimmedSearch !== "") {
    params.set("search", trimmedSearch);
  }
  return `/shipping/gosi-details?${params.toString()}`;
}

export function buildManufacturingWorkOrderDetailPath(buildOrderId: number): string {
  return `/manufacturing-management/work-orders/${String(buildOrderId)}`;
}

export function buildMrpPurchaseOrderDetailPath(purchaseOrderId: number): string {
  return `/mrp/purchase-orders/${String(purchaseOrderId)}`;
}

export function buildMrpSupplierDetailPath(supplierId: number): string {
  return `/mrp/suppliers?supplier=${String(supplierId)}`;
}

export function buildMrpAdjustmentDetailPath(adjustmentId: number): string {
  return `/mrp/adjustments/${String(adjustmentId)}`;
}

export function buildMrpPurchaseInvoiceDetailPath(
  purchaseInvoiceId: number,
  search?: string | null,
): string {
  const base = `/mrp/purchase-invoices/${String(purchaseInvoiceId)}`;
  const trimmedSearch = search?.trim();
  if (trimmedSearch == null || trimmedSearch === "") {
    return base;
  }
  const params = new URLSearchParams();
  params.set("search", trimmedSearch);
  return `${base}?${params.toString()}`;
}

export function buildManufacturingTransfersWorkbenchPath(input?: {
  transferOrderId?: number;
  search?: string | null;
}): string {
  const params = new URLSearchParams();
  if (input?.transferOrderId != null && Number.isFinite(input.transferOrderId) && input.transferOrderId > 0) {
    params.set("transfer_order_id", String(input.transferOrderId));
  }
  const trimmedSearch = input?.search?.trim();
  if (trimmedSearch != null && trimmedSearch !== "") {
    params.set("search", trimmedSearch);
  }
  const query = params.toString();
  return query === "" ? "/manufacturing-management/transfers" : `/manufacturing-management/transfers?${query}`;
}

export function buildMrpIncomingPartsPath(input?: {
  po?: string | null;
  cpn?: string | null;
  location?: string | null;
}): string {
  const params = new URLSearchParams();
  const trimmedPo = input?.po?.trim();
  if (trimmedPo != null && trimmedPo !== "") {
    params.set("po", trimmedPo);
  }
  const trimmedCpn = input?.cpn?.trim();
  if (trimmedCpn != null && trimmedCpn !== "") {
    params.set("cpn", trimmedCpn);
  }
  const trimmedLocation = input?.location?.trim().toLowerCase();
  if (trimmedLocation != null && trimmedLocation !== "") {
    params.set("location", trimmedLocation);
  }
  const query = params.toString();
  return query === "" ? "/mrp/incoming-parts" : `/mrp/incoming-parts?${query}`;
}

export function buildShippingInboundReceivePath(sourceType: string, sourceId: string): string {
  return `/shipping/receive/${encodeURIComponent(sourceType)}/${encodeURIComponent(sourceId)}`;
}

export function buildInboundReceiptReviewPath(receiptId: string | number): string {
  return `/shipping/inbound/receipts/${encodeURIComponent(String(receiptId))}`;
}
